<template>
  <div>
    <div
      :class="classes"
      :style="styles"
    >
      <div
        class="Expander__inner"
        ref="innerRef"
      >
        <div
          class="Expander__positioner"
          :style="positionerStyles"
        >
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/services/event-bus'

export default {
  name: 'Expander',
  props: {
    collapsable: {
      type: Boolean,
      default: true
    },
    expanded: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      expandedHeight: 0,
      instant: null
    }
  },
  computed: {
    classes () {
      return {
        'Expander': this.collapsable
      }
    },
    styles () {
      return this.collapsable ? {
        'height': this.expanded ? this.expandedHeight + 'px' : '0',
        'transitionDuration': this.transitionDuration()
      } : {}
    },
    positionerStyles () {
      return this.collapsable ? {
        'bottom': this.expanded ? '0' : this.expandedHeight + 'px',
        'transitionDuration': this.transitionDuration()
      } : {}
    }
  },
  methods: {
    setExpandedHeight (instant) {
      this.instant = instant
      setTimeout(() => {
        const expandedHeight = this.$refs.innerRef ? this.$refs.innerRef.clientHeight : 0
        this.expandedHeight = expandedHeight
      }, 10)
    },
    transitionDuration () {
      return this.instant ? '0s' : (parseInt(this.expandedHeight * 0.001 * 1000, 10) / 1000) + 's'
    },
    setInstantDone () {
      this.instant = null
    }
  },
  mounted () {
    this.setExpandedHeight()
    window.addEventListener('resize', this.setExpandedHeight)
    EventBus.$on('expander:resize', this.setExpandedHeight)
    EventBus.$on('expander:resizedone', this.setInstantDone)
  },
  destroyed () {
    window.removeEventListener('resize', this.setExpandedHeight)
    EventBus.$off('expander:resize', this.setExpandedHeight)
    EventBus.$off('expander:resizedone', this.setInstantDone)
  }
}
</script>

<style lang="scss" scoped>
.Expander {
  height: 0;
  overflow: hidden;
  transition: height ease-out 0.5s;

  &__positioner {
    position: relative;
    bottom: 100%;
    transition: bottom ease-out 0.5s;
  }
}
</style>
